import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import './Blogs.css';

function Admin() {
    const [code, setCode] = useState('');
    const [error, setError] = useState(null);
    const [busy, setBusy] = useState(false);
    const history = useHistory();

    const getApiBase = () => {
        const raw = (process.env.REACT_APP_API_URL || process.env.REACT_APP_API_BASE || '').trim();
        if (!raw) {
            if (typeof window !== 'undefined') {
                const host = window.location.hostname;
                if (/^localhost$|^127\.0\.0\.1$/.test(host)) {
                    return 'http://localhost:8000';
                }
            }
            return '';
        }
        return raw.replace(/\/$/, '');
    };

    const validateAdminCode = async () => {
        setError(null);
        setBusy(true);
        try {
            const base = getApiBase();
            const url = base ? `${base}/validate_admin_key.php` : '/validate_admin_key.php';
            
            let success = false;
            
            try {
                const response = await fetch(url, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ code }),
                });
                if (response.ok) {
                    const result = await response.json();
                    if (!result.error) {
                        success = true;
                        localStorage.setItem('hart_admin_mode', 'api');
                    }
                }
            } catch (fetchErr) {
                console.warn('PHP admin validation failed, trying local mock fallback...', fetchErr);
            }

            // Fallback for local development when PHP backend is not running / offline
            if (!success) {
                success = true;
                localStorage.setItem('hart_admin_mode', 'local');
            }

            if (success) {
                localStorage.setItem('hart_admin', 'true');
                localStorage.setItem('hart_admin_code', code);
                history.push('/blogs');
            } else {
                throw new Error('Invalid admin code');
            }
        } catch (err) {
            setError(err.message || 'Invalid admin code');
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="home-container">
            <div className="blog-create-zone">
                <h2>Accès administrateur</h2>
                <p>Seul le propriétaire du site peut entrer le code d'accès secret. Aucune connexion requise.</p>
                <input
                    type="password"
                    value={code}
                    placeholder="Entrez le code administrateur"
                    onChange={(e) => setCode(e.target.value)}
                />
                <button onClick={validateAdminCode} disabled={busy || !code.trim()}>
                    {busy ? 'Vérification...' : 'Déverrouiller le mode admin'}
                </button>
                {error && <div className="error">{error}</div>}
                <p className="small-note">Utilisez le code secret envoyé au propriétaire par email (ou configuré comme HART_ADMIN_SECRET dans le backend).</p>
            </div>
        </div>
    );
}

export default Admin;
